export default "__VITE_ASSET__CdNOVUu$__"